import {
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import { messagesAdapter } from '../adapters/messages.adapter';
import { IChatCommandShowTypingMessage } from '@enuan/chat__utils';
import { IClientMessage } from '../../interfaces/IClientMessage';
import {
	popMessageStack,
	resetReducer,
} from '../../reduxStore/actions/actions';

export const messagesStackSlice = createSlice({
	name: 'messagesStack',
	initialState: messagesAdapter.getInitialState<{
		agentTypingMessage?: IChatCommandShowTypingMessage;
	}>({}),
	reducers: {
		addMessage: {
			prepare: (message: IClientMessage) => ({
				payload: { ...message, _meta: { ...message._meta, read: false } },
			}),
			reducer: messagesAdapter.upsertOne,
		},
		removeMessage: messagesAdapter.removeOne,
		setAgentTypingMessage: (
			state,
			action: PayloadAction<IChatCommandShowTypingMessage | undefined>,
		) => {
			state.agentTypingMessage = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(resetReducer, () => {
				return messagesAdapter.getInitialState();
			})
			.addCase(popMessageStack, (state, action) => {
				messagesAdapter.removeOne(state, action.payload.client_id);
			})
			.addDefaultCase(() => {});
	},
});
